import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { formatIndustryPath, getLeafIndustry, isKnownIndustrySegment } from "./industryPath";

interface IIndustryPathCellProps {
    category: string;
    subCategory: string;
}

const IndustryLeaf = styled(Text)<{ $interactive: boolean }>`
    ${({ $interactive }) =>
        $interactive &&
        css`
            cursor: help;

            &:hover {
                text-decoration: underline dotted ${colorsPalettes.carbon[300]};
                text-underline-offset: 3px;
            }
        `}
`;

export const IndustryPathCell = ({ category, subCategory }: IIndustryPathCellProps) => {
    const hasParentPath = isKnownIndustrySegment(subCategory);

    const leaf = (
        <IndustryLeaf
            fontVariant="body2"
            color={colorsPalettes.carbon[500]}
            $interactive={hasParentPath}
            data-automation="industry-path-cell"
        >
            {getLeafIndustry(category, subCategory)}
        </IndustryLeaf>
    );

    // Only surface a tooltip (and its hover affordance) when the sub-industry hides a parent.
    if (!hasParentPath) {
        return leaf;
    }

    return (
        <Tooltip
            content={formatIndustryPath(category, subCategory)}
            placement="top"
        >
            {leaf}
        </Tooltip>
    );
};
